import axios from "axios";

// Multi-tenant: when the SPA is served on a real custom domain, the Emergent
// ingress also exposes /api/* on that same host. Using a same-origin baseURL
// avoids CORS entirely (browsers refuse Allow-Origin "*" + credentials).
// Falls back to the build-time backend URL for the preview/dev environment.
const BUILD_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function resolveApiBase() {
  if (typeof window === "undefined") return `${BUILD_BACKEND_URL}/api`;
  const host = window.location.hostname;
  const sameOriginHosts = [
    "digital-mallorca.de",
    "starlink-mallorca.de",
    "internet-mallorca.de",
    "kameramann-mallorca.de",
    "streamsetup-mallorca.de",
    "irlstreams-mallorca.de",
    "onlinemarketing-mallorca.de",
  ];
  const isCustomDomain = sameOriginHosts.some(
    (d) => host === d || host.endsWith(`.${d}`)
  );
  if (isCustomDomain) return `${window.location.origin}/api`;
  return `${BUILD_BACKEND_URL}/api`;
}

export const API_BASE = resolveApiBase();

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export function formatApiError(detail) {
  if (detail == null) return "Etwas ist schiefgelaufen. Bitte erneut versuchen.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
